<template>
  <div>
    <div class="wreppar">
      <div class="headers">
        <Header></Header>
      </div>
      <div class="centent">
        <div class="centent_left">
          <div class="left_lie" v-for="(item,index) in newData">
            <p @click="xiang(index)">{{item.title}}</p>
            <p>{{item.content}}</p>
          </div>
        </div>
        <div class="centent_right">
          <Section></Section>
        </div>
      </div>
      <div class="headers">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
import Section from "../section/section.vue";
export default {
  data() {
    return {
      newData: "",
      id: ""
    };
  },
  components: { Header, Footer, Section },
  methods: {
    games_app: function() {
      const rLoading = this.openLoading();
      let that = this;
      // let token = JSON.parse(localStorage.getItem("username")).code;
      that.$http
        .get(that.g.ajaxurl + "teams/new", {
          // headers: {
          //   Authorization: "Basic " + window.btoa(token + ":")
          // }
        })
        .then(res => {
          this.newData = res.data.data;
          console.log(this.newData);
          rLoading.close();
        });
    },
    xiang: function(a) {
      this.id = this.newData[a].id;
      this.$router.push({
        path: "/chessnews",
        query: {
          id: this.id
        }
      });
    }
  },
  mounted() {
    let that = this;
    //分享
    that.games_app();
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.centent {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 2.2rem;
  margin-bottom: 0.6rem;
}
.centent_left {
  width: 70%;

  font-size: 0.2rem;
}
.left_lie {
  display: flex;
  justify-content: space-between;
  line-height: 0.5rem;
  border-bottom: 1px #ccc dashed;
}
.centent_right {
  width: 26%;
}
.block {
  text-align: center;
  margin-top: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/journalism.vue